import { USERS } from "../../Constants/Endpoints";
import { ApiRequestInterceptor } from "../apiRequest";

/**
 * Actualiza el perfil del usuario autenticado (phone, delivery, etc.)
 * El token se adjunta automáticamente por ApiRequestInterceptor.
 */
export const fetchUpdateProfile = async (profileData) => {
  const method = "PATCH";
  const response = await ApiRequestInterceptor(USERS.updateProfile, method, profileData);

  const { code, data } = response;

  return {
    statusCode: code ?? 500,
    message: data?.message || null,
    user: data?.user || null,
  };
};
